export enum UserType {
  ADMIN = "ADMIN",
  SELLER = "SELLER",
}
